import PoliceReportPVDetailAlloggiati from 'Components/Dashboard/PoliceReport/PoliceReportDetail/PV/ALLOGGIATI/PoliceReportDetail';
import PoliceReportPVDetailSES from 'Components/Dashboard/PoliceReport/PoliceReportDetail/PV/SES/PoliceReportDetail';
import { useParams, Navigate, Outlet } from 'react-router-dom';

export default function PlatformPoliceReportRouter() {
  const { platform } = useParams();
  const normalized = platform?.toLowerCase();

  if (normalized === 'alloggiati') {
    return <PoliceReportPVDetailAlloggiati />;
  } else {
    return <PoliceReportPVDetailSES />;
  }
}
